export const numberFormatter = (quota: any) => {
  if (!quota) {
    return 0;
  }
  return parseFloat(Number(quota).toFixed(1)).toLocaleString('id-ID');
};
